<template>
	<screen class="forgot-password-view" type="blue">
		<template slot="header">
			<ui-header type="light" @click="onDismiss">
				<h2 slot="title">Forgot Password</h2>
				Enter your email below to have a link emailed to you with
				instructions on how to reset your password.
			</ui-header>
		</template>
		<form v-on:submit.prevent="onSubmit">
			<label>
				<ui-input type="blue" placeholder="Email" v-model="email" />
			</label>
			<label>
				<ui-button
					color="white"
					native-type="submit"
					:loading="isLoading"
					>Submit</ui-button
				>
			</label>
		</form>
	</screen>
</template>

<script>
import { mapActions } from 'vuex'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import UiHeader from '../../ui/Header'
import Screen from '../../ui/Screen'

export default {
	name: 'forgot-password',
	components: { UiButton, UiInput, UiHeader, Screen },
	data() {
		return {
			isLoading: false,
			email: ''
		}
	},
	methods: {
		...mapActions(['forgotPassword']),
		onSubmit() {
			this.isLoading = true
			this.forgotPassword(this.email)
				.then((response) => {
					this.isLoading = false
					this.$swal('Success', response.message).then(() => {
						this.navigate({ name: 'welcome' }, 'down')
					})
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal('Error', message)
				})
		},
		onDismiss() {
			this.navigate({ name: 'login' }, 'back')
		}
	}
}
</script>

<style lang="scss">
@import '../../styles/elements';
</style>
